import React, { useEffect, useRef, useState } from 'react';
import { Button, ButtonGroup, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Table } from 'react-bootstrap';
import Sidebar from '../../Components/base/sidebar';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { BsEye, BsPencilSquare, BsTrash, BsTrashFill } from 'react-icons/bs';
import CreateNew from '../../Components/Button/CreateNew';
import CurrentDraftsTable from '../../Components/Tables/CurrentDraftsTable';
import CurrentLatestTable from '../../Components/Tables/CurrentLatestTable';
import AuthModal from '../../Components/Modal/AuthenticateModal';
import { toast } from 'sonner';

interface Item {
    id: number;
    category: string;
    sub_category: string;
    title: string;
    author: string;
    status: string;
    // Add more properties as per your item structure
}

export default function LongStory() {
    const [items, setItems] = useState<Item[]>([]);
    const navigate = useNavigate();
    const isMounted = useRef(true);
    const [id, setItemToDelete] = useState<number | null>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openAuthModal = () => {
		setIsModalOpen(true); 
	};
	
	const closeAuthModal = () => {
		setIsModalOpen(false); 
	};

    useEffect(() => {
        isMounted.current = true;

        const fetchData = async () => {
            try {
                const response = await axios.get('https://cdn.pulp.ph/api/v1/long-stories');
                if (isMounted.current) {
                    setItems(response.data.longStory.data);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();

        return () => {
            isMounted.current = false;
        };
    }, []);

    const handleEditLongstory = (id: number) => {
        navigate('/update/longStory', { state: { id } });
    };

    const handleViewLongstory = (id: number) => {
        window.open(`https://pulpmagazine.com/article/long_story/${id}`, '_blank');
    };

    const handleDelete = async (id: number) => {
        setItemToDelete(id);
        openAuthModal();
    };

    const confirmDelete = async () => {
        if (id === null) return;

        try {
            const authToken = localStorage.getItem('authToken');
            await axios.delete(`https://cdn.pulp.ph/api/v1/longStory/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                }
            });

            toast.success(<p className="text-[16px]">Content was deleted successfully!</p>, {
                duration: 1500,
            });

            closeAuthModal();
            setItemToDelete(null);

            setTimeout(() => {
                window.location.reload(); 
            }, 1600);
        } catch (error) {
            console.error('There was an error submitting the form!', error);

            toast.error(<p className="text-[16px]">Unable to delete. Please try again.</p>, {
                duration: 1500,
            });
        }
    }

    return (
        <React.Fragment>
            <AuthModal
                isOpen={isModalOpen}
                onClose={closeAuthModal}
                title="Action Verification"
                content={<div className='text-base mb-3'>Are you sure you want to delete this content?</div>}
                footer={
                <>
                    <button 
                        className="m-0 px-4 py-2 GraphikSemibold text-sm text-gray-700 bg-gray-200 rounded hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400"
                        onClick={closeAuthModal}>
                        Close
                    </button>

                    <button 
                        className="m-0 px-4 py-2 GraphikSemibold text-sm text-white bg-red-500 rounded hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400"
                        onClick={confirmDelete}>
                        Confirm
                    </button>
                </>
                }
            />

            <div className="w-full p-5">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="GraphikSemibold text-[20px]">List of Long Stories</h2>
                    <CreateNew />
                </div>

                <div className="mt-3">
                    <h3 className="GraphikSemibold text-[16px] mb-2">Pending Long Stories</h3>
                    <CurrentDraftsTable
                        items={items}
                        onView={handleViewLongstory}
                        onEdit={handleEditLongstory}
                        onDelete={handleDelete}
                    />
                </div>

                <div className="mt-3">
                    <h3 className="GraphikSemibold text-[16px] mb-2">Published Long Stories</h3>
                    <CurrentLatestTable
                        items={items}
                        onView={handleViewLongstory}
                        onEdit={handleEditLongstory}
                        onDelete={handleDelete}
                    />
                </div>
            </div>
        </React.Fragment>
    )
}
